import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { getAllBanks } from "../../../services/apiSettings";
import { saveDeposit, editDeposit } from "../../../services/apiSubPayments";
import PopUp from "../../PopUp";
import Loader from "../../Loader";
import moment from "moment";
import Select from "react-select";
import { getAllVendors } from "../../../services/apiSettings";

const AddDeposits = ({
  open,
  onClose,
  editMode,
  errors,
  setErrors,
  userSet,
  initialData, // pass existing data for edit
}) => {
  // State for form fields
  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      height: "32px !important",
      minWidth: "200px !important",
      marginTop: "0px",
      borderRadius: "0.375rem",
      borderColor: "#dee2e6",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#dee2e6",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      marginTop: "2px", // Reduced spacing between select and dropdown
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#0d6efd"
        : state.isFocused
          ? "#e9ecef"
          : "white",
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
      fontSize: "13px", // Option font size
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "13px",
      color: "#000000", // Black color for placeholder
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "13px",
      color: "#000000",
    }),
    input: (provided) => ({
      ...provided,
      fontSize: "13px",
      color: "#000000",
    }),
  };
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [openPopUp, setOpenPopUp] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [selectedVendorid, setSelectedVendorid] = useState("");

  const [formData, setFormData] = useState({
    vendorId: "",
    amount: 0,
    modeofPayment: "",
    bank: "",
    paymentDate: "",
    remark: "",
  });
  const [BankList, setBankList] = useState([]);

  const fetchBanks = async () => {
    setIsLoading(true);

    try {
      const listbanks = await getAllBanks();
      setBankList(listbanks?.bank || []);
      setIsLoading(false);
    } catch (error) {
      console.log("Bank list Error", error);
      setIsLoading(false);
    }
  };

  const fetchVendorList = async () => {
    try {
      const listvendors = await getAllVendors();
      setVendorList(listvendors?.vendors || []);
    } catch (error) {
      console.log("Cannot fecth vendor", error);
    }
  };

  useEffect(() => {
    fetchBanks();
    fetchVendorList();
  }, []);

  useEffect(() => {
    console.log(userSet, "userSet");
    if (editMode && userSet && BankList.length) {
      const selectedBank = BankList.find((b) => b.bankName === userSet.bank);
      setFormData({
        vendorId: userSet.vendorId?._id || "",
        amount: userSet.amount ?? "",
        modeofPayment: userSet.modeofPayment || "",
        bank: selectedBank ? selectedBank._id : "",
        paymentDate: userSet.paymentDate
          ? moment(userSet.paymentDate, ["DD-MM-YYYY", moment.ISO_8601]).format(
              "YYYY-MM-DD",
            )
          : "",
        remark: userSet.remark || "",
      });
    } else {
      setFormData({
        vendorId: "",
        amount: 0,
        modeofPayment: "",
        bank: "",
        paymentDate: "",
        remark: "",
      });
    }
  }, [editMode, userSet, BankList]);

  // Handle input changes
  const handleChange = (e, selectedOption) => {
    let name, value;

    if (selectedOption) {
      // React Select case: selectedOption is the full option object or null
      name = "vendorId"; // Fixed name for vendor
      value = selectedOption ? selectedOption.value : "";
    } else {
      // Native input/select case
      name = e.target.name;
      value = e.target.value;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear errors for the changed field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.vendorId) newErrors.vendorId = "Vendor is required";
    if (!formData.amount) newErrors.amount = "Amount is required";
    if (!formData.modeofPayment)
      newErrors.modeofPayment = "Mode Of Payment is required";
    if (!formData.paymentDate)
      newErrors.paymentDate = "Payment Date is required";
    if (formData.modeofPayment == "bank") {
      if (!formData.bank) newErrors.bank = "Bank is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  // Save handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    // You can add validation here if needed
    if (!validateForm()) return;
    setIsLoading(true);

    try {
      let response;
      if (editMode) {
        console.log("Edit mode formData:", formData);
        formData.depositId = userSet?._id;
        response = await editDeposit(formData);
        setIsLoading(false);
      } else {
        // Add new role
        console.log("Add mode formData:", formData);
        response = await saveDeposit(formData);
        setIsLoading(false);
      }
      if (response.status === true) {
        if (editMode) {
          setMessage("Deposit Updated Successfully");
        } else {
          setMessage("Deposit Saved Successfully");
        }

        setOpenPopUp(true);
        setFormData({
          vendorId: "",
          amount: 0,
          modeofPayment: "",
          bank: "",
          paymentDate: "",
          remark: "",
        });
        onClose();
        setIsLoading(false);
      } else {
        setMessage(response.message);
        setOpenPopUp(true);
        setIsLoading(false);
      }
    } catch (error) {
      setMessage("API Failed");
      setOpenPopUp(true);
      console.error("Error saving/updating deposits", error);
      setIsLoading(false);
    }

    console.log("Payload:", formData);
    onClose();
  };

  useEffect(() => {
    console.log(open, "open");
    console.log(editMode, "isEditcharge");
    if (editMode == false && open == true) {
      resetFields();
    }
  }, [editMode, open]);

  const resetFields = () => {
    setFormData({
      vendorId: "",
      amount: 0,
      modeofPayment: "",
      bank: "",
      paymentDate: "",
      remark: "",
    });
  };

  const vendorOptions = vendorList.map((vendor) => ({
    value: vendor._id,
    label: vendor.vendorName,
  }));

  const handleVendorSelectChange = (selectedOption) => {
    const vendorId = selectedOption ? selectedOption.value : "";
    setSelectedVendorid(vendorId);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            // Prevent dialog from closing when clicking outside
            return;
          }
          onClose(); // Allow dialog to close for other reasons
        }}
        fullWidth
        maxWidth="sm"
      >
        <div className="d-flex justify-content-between">
          <DialogTitle>
            {editMode ? "Edit Deposits" : "Add Deposits"}
          </DialogTitle>
          <div className="closeicon">
            <i className="bi bi-x-lg" onClick={onClose}></i>
          </div>
        </div>
        <DialogContent style={{ marginBottom: "40px" }}>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col mb-0">
                <label className="form-label">
                  Vendor <span className="required">*</span>:
                </label>
                <Select
                  options={vendorOptions}
                  onChange={(selectedOption) =>
                    handleChange(null, selectedOption)
                  } // Pass selectedOption as second arg
                  value={vendorOptions.find(
                    (opt) => opt.value === formData.vendorId,
                  )}
                  placeholder="Choose Vendor Name"
                  isClearable
                  isSearchable
                  styles={customSelectStyles}
                  classNamePrefix="react-select"
                />
                {errors.vendorId && (
                  <span className="invalid">{errors.vendorId}</span>
                )}
              </div>
              <div className="col mb-3">
                <label className="form-label">
                  Amount <span className="required">*</span>:
                </label>
                <input
                  name="amount"
                  type="number"
                  className="form-control custom-input-styles"
                  value={formData.amount}
                  onChange={handleChange}
                />
                {errors.amount && (
                  <span className="invalid">{errors.amount}</span>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-6 mb-3 align-items-start">
                <div className="">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label"
                  >
                    Mode Of Payment <span className="required"> * </span> :
                  </label>
                  <div className="vessel-select">
                    <select
                      name="modeofPayment"
                      className="form-select vesselbox"
                      aria-label="Default select example"
                      onChange={handleChange}
                      value={formData.modeofPayment}
                    >
                      <option value="">Mode Of payment </option>
                      <option value="Cash">Cash </option>
                      <option value="Bank">Bank</option>
                    </select>
                    {errors.modeofPayment && (
                      <span className="invalid">{errors.modeofPayment}</span>
                    )}
                  </div>
                </div>
              </div>
              {formData?.modeofPayment == "Bank" && (
                <>
                  <div className="col-6 mb-3 align-items-start">
                    <div className="">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label"
                      >
                        Bank <span className="required"> * </span> :
                      </label>
                      <div className="vessel-select">
                        <select
                          name="bank"
                          className="form-select vesselbox"
                          aria-label="Default select example"
                          onChange={handleChange}
                          value={formData.bank}
                        >
                          <option value="">Choose Bank</option>
                          {BankList.map((banks) => (
                            <option key={banks._id} value={banks._id}>
                              {banks.bankName}
                            </option>
                          ))}
                        </select>
                        {errors.bank && (
                          <span className="invalid">{errors.bank}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="row">
              <div className="col-6 mb-3 align-items-start">
                <div className="">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label"
                  >
                    Payment Date <span className="required"> * </span> :
                  </label>
                  <div className="vessel-select">
                    <input
                      name="paymentDate"
                      type="date"
                      className="form-control custom-picker-styles"
                      id="paymentDate"
                      placeholder=""
                      onChange={handleChange}
                      value={formData.paymentDate}
                    ></input>
                    {errors.paymentDate && (
                      <span className="invalid">{errors.paymentDate}</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-6 mb-3 align-items-start">
                <div className="">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label"
                  >
                    Remarks:
                  </label>
                  <div className="vessel-select">
                    <textarea
                      name="remark"
                      className="form-control vessel-voyage"
                      id="remark"
                      value={formData.remark}
                      onChange={handleChange}
                      style={{ width: "100%", resize: "none" }}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="btnuser">
              <button className="btn btna submit-button btnfsize" type="submit">
                Submit
              </button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Loader isLoading={isLoading} />

      {openPopUp && (
        <PopUp message={message} closePopup={() => setOpenPopUp(false)} />
      )}
    </>
  );
};

export default AddDeposits;
